import api from './axios'

/**
 * Department Form Access API
 * Manages which forms departments can access and field visibility
 */
export const departmentFormAccessApi = {
    /**
     * Get all available forms for assignment
     */
    getAvailableForms: async () => {
        const response = await api.get('/department-form-access/forms')
        return response
    },

    /**
     * Get forms accessible by a department
     */
    getByDepartment: async (departmentId) => {
        const response = await api.get(`/department-form-access/department/${departmentId}`)
        return response
    },

    /**
     * Get departments that can access a form
     */
    getByForm: async (formId) => {
        const response = await api.get(`/department-form-access/form/${formId}`)
        return response
    },

    /**
     * Update access - visible fields and permissions
     */
    update: async (departmentId, formId, data) => {
        const response = await api.put(`/department-form-access/${departmentId}/${formId}`, data)
        return response
    },

    /**
     * Assign multiple forms to a department
     */
    assignForms: async (departmentId, formIds, visibleFieldsMap = null) => {
        const response = await api.post(`/department-form-access/${departmentId}/assign`, {
            form_ids: formIds,
            visible_fields_map: visibleFieldsMap
        })
        return response
    },

    /**
     * Remove form access from department
     */
    remove: async (departmentId, formId) => {
        const response = await api.delete(`/department-form-access/${departmentId}/${formId}`)
        return response
    }
}

export default departmentFormAccessApi
